import { call, put } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import * as Constants from '../../../constants';
import { getInDomain } from '../../../domains/externalUtils';
import { putAndWait } from '../../../sagas/TaskManager';

export function* APSFeedback(action) {
  const { sourceId, trackToken, isPositive, skip } = action.payload;
  const params = {
    sourceId,
    itemPandoraId: trackToken,
    isPositive,
  };

  if (action.type === Constants.UseCases.ActionTypes.REMOVE_TRACK_FEEDBACK) {
    yield call(putAndWait, getInDomain('playback.actions.removeItemFeedback')(params));
  } else {
    yield call(putAndWait, getInDomain('playback.actions.addItemFeedback')(params));
  }

  if (skip) {
    yield put(getInDomain('playback.actions.playCurrentItemForSource')({ sourceId }));
  }
}

export function* stationFeedback(action) {
  const { trackToken, isPositive, skip } = action.payload;
  if (action.type === Constants.UseCases.ActionTypes.REMOVE_TRACK_FEEDBACK) {
    const actionCreator = isPositive
      ? Actions.Playback.unThumbUpTrack
      : Actions.Playback.unThumbDownTrack;
    yield put(actionCreator({ trackToken }));
  } else if (isPositive) {
    yield put(Actions.Playback.thumbUpTrack(trackToken));
  } else {
    yield put(Actions.Playback.thumbDownTrack(trackToken, skip));
  }
}

export function* triggerFeedbackHappened(action) {
  if (action.type === Constants.UseCases.ActionTypes.REMOVE_TRACK_FEEDBACK) {
    yield put(Actions.Integrations.feedbackRemoved(action.payload));
  } else {
    yield put(Actions.Integrations.feedbackAdded(action.payload));
  }
}
